export function timeIncludesSeconds(time: string): boolean {
  const partsLength = time.split(":")?.length;
  return partsLength === 3;
}

export function toTimeWithSeconds(time: string): string {
  if (!time) return time;
  return timeIncludesSeconds(time) ? time : `${time}:00`;
}

export function toTimeWithoutSeconds(time: string): string {
  if (!time) return time;
  return timeIncludesSeconds(time) ? time.slice(0, -3) : time;
}
